import * as EasyAsync from 'redux-easy-async';
import { MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE } from './constants';
import { ApolloClient } from '@apollo/client';

export interface AsyncAction {
  args: Record<string, any>;
  meta: Record<string, any>;
  payload: Record<string, any>;
}

type CreateAsyncActionFn<T extends AsyncAction> = (args: T['args']) => {
  makeRequest: (
    state: Record<string, any>,
    context: {
      apolloClient: ApolloClient<object>;
    },
  ) => Promise<T['payload']>;
  meta?: T['meta'];
};

export const createAsyncAction = <T extends AsyncAction>(
  actionName: string,
  fn: CreateAsyncActionFn<T>,
  options?: any,
) =>
  EasyAsync.createAsyncAction(actionName, fn, {
    namespace: MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE,
    ...options,
  });
